import { z } from 'zod';

import {
  END_BEFORE_START_ERROR_KEY,
  requiredString,
} from '@/shared/utils/validation';

export const sewBillingCycleRangeExportValidationInputSchema = z
  .object({
    startBillingCycleTs: requiredString(),
    endBillingCycleTs: requiredString(),
  })
  .superRefine((data, ctx) => {
    if (new Date(data.endBillingCycleTs) < new Date(data.startBillingCycleTs)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: END_BEFORE_START_ERROR_KEY,
        path: ['endBillingCycleTs'],
      });
    }
  });
